import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardList, Sun, CalendarCheck } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    day: 'FRIDAY',
    label: 'Prep',
    icon: <ClipboardList className="w-8 h-8 text-primary" data-id="element-85" />,
    description: 'Set up your home for success using the checklist.'
  }, {
    day: 'SAT + SUN',
    label: 'Immersion',
    icon: <Sun className="w-8 h-8 text-primary" data-id="element-86" />,
    description: 'Run the protocol and lock in the body–brain connection.'
  }, {
    day: 'MONDAY',
    label: 'Real Life',
    icon: <CalendarCheck className="w-8 h-8 text-primary" data-id="element-87" />,
    description: 'Do a short outing + send them to daycare with confidence.'
  }];
  return <section className="py-20 px-4" data-id="element-88">
      <div className="max-w-5xl mx-auto" data-id="element-89">
        <div className="text-center mb-16" data-id="element-90">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-91">
            Your 72-Hour Timeline
          </h2>
        </div>

        <div className="relative" data-id="element-92">
          {/* Desktop connecting line */}
          <div className="hidden md:block absolute top-[4.5rem] left-[10%] right-[10%] h-1 bg-border z-0" data-id="element-93"></div>

          {/* Mobile connecting line */}
          <div className="md:hidden absolute top-0 bottom-0 left-[2.25rem] w-1 bg-border z-0" data-id="element-94"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-95">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="flex flex-row md:flex-col items-start md:items-center gap-6 md:gap-4" data-id="element-96">
                <div className="flex-shrink-0 w-20 h-20 bg-white rounded-full border-4 border-accent shadow-md flex items-center justify-center relative z-10" data-id="element-97">
                  {step.icon}
                </div>

                <div className="md:text-center pt-2 md:pt-0" data-id="element-98">
                  <div className="inline-block px-3 py-1 bg-primary/10 text-primary font-bold text-sm rounded-full mb-3" data-id="element-99">
                    {step.day}
                  </div>
                  <h3 className="text-xl font-bold mb-2 font-serif" data-id="element-100">
                    {step.label}
                  </h3>
                  <p className="text-foreground/70 leading-relaxed" data-id="element-101">
                    {step.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}